import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

const LanguageSwitcher = ({ className = "" }) => {
  const { currentLanguage, changeLanguage } = useLanguage();

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'me' : 'en';
    changeLanguage(newLanguage);
  };

  const currentLangDisplay = getTranslation(currentLanguage, 'language.current');
  const switchToDisplay = getTranslation(currentLanguage, 'language.switch_to');

  return (
    <div className={`language-switcher ${className}`}>
      <button
        onClick={toggleLanguage}
        className="flex items-center space-x-2 px-6 md:px-8 py-4 md:py-5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 shadow-2xl"
        title={`Switch to ${switchToDisplay}`}
        style={{ color: '#004746' }}
      >
        <span className="text-sm font-medium">
          {currentLanguage === 'en' ? '🇺🇸' : '🇲🇪'}
        </span>
        <span className="text-sm font-medium hidden sm:inline" style={{ color: '#004746' }}>
          {currentLangDisplay}
        </span>
        <svg 
          className="w-4 h-4 transition-transform duration-200" 
          fill="none" 
          stroke="#004746" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
        </svg>
      </button>
    </div>
  );
};

export default LanguageSwitcher;